import { APP_PERMISSIONS } from '@exam-center/permission';
import { Link } from '@exam-center/router';
import { AddRoundedIcon, Button } from '@shared/components';
import { WithPermission } from '@shared/permissions';

export default function BlockedUserCreationButton() {
  return (
    <WithPermission
      requiredPermission={APP_PERMISSIONS.ADMIN_BLOCKLIST_MANAGEMENT.BLOCKED_USER.CREATE}
    >
      <Button
        size='large'
        startIcon={<AddRoundedIcon />}
        component={Link}
        to='/admin/blocklist/create'
      >
        เพิ่มรายชื่อ
      </Button>
    </WithPermission>
  );
}
